import React from 'react';
import { Nav } from 'react-bootstrap';
import { useTheme } from '../contexts/ThemeContext';

/**
 * @param {{ className?: string, asNavLink?: boolean }} props
 */
export function ThemeToggle({ className = '', asNavLink = true }) {
  const { theme, toggleTheme } = useTheme();
  const title = theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode';
  const icon = <i className={`bi ${theme === 'dark' ? 'bi-sun' : 'bi-moon-stars'}`} aria-hidden="true" />;
  const linkClass = `topnav-icon topnav-icon-theme ${className}`.trim();

  if (asNavLink) {
    return (
      <Nav.Link onClick={toggleTheme} title={title} className={linkClass} aria-label={title}>
        {icon}
      </Nav.Link>
    );
  }

  return (
    <button
      type="button"
      className={`btn btn-outline-secondary border-0 ${className}`.trim()}
      onClick={toggleTheme}
      title={title}
      aria-label={title}
    >
      {icon}
    </button>
  );
}

export default ThemeToggle;
